/**
 * Retrieves the value of a specific cookie by name.
 * @param {string} name - The name of the cookie to retrieve.
 * @returns {string|null} The cookie value if found, otherwise null.
 */
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

/**
 * Handles click event on the featured video.
 * Checks for OneTrust consent and displays the iframe accordingly.
 */
document.querySelector(".featured-video").addEventListener('click', function() {
    // Retrieve OneTrust consent status from cookies
    const oneTrustStatus = getCookie('OptanonConsent');
    const hasVideoConsent = oneTrustStatus && 
        (decodeURIComponent(oneTrustStatus).includes(onetrust_video_consent_category + ':1') ||
        decodeURIComponent(oneTrustStatus).includes(onetrust_video_consent_category_secondary + ':1')
    );

    // If consent is granted, show the video
    if (hasVideoConsent) {
        const videoLazyLoad = this.querySelector('.video-lazy-load');
        if (videoLazyLoad) {
            const iframe = document.createElement("iframe");
            iframe.src = videoLazyLoad.dataset.src;
            iframe.width = "850";
            iframe.height = "480";
            iframe.frameBorder = "0";
            iframe.allowFullscreen = true;
            iframe.id = "dynamic-video";

            // Insert the iframe before the videoLazyLoad element
            videoLazyLoad.parentNode.insertBefore(iframe, videoLazyLoad);

            if (videoLazyLoad.dataset.type === 'youtube') {
                initializeYTPlayer();
            }
        }
        document.querySelector(".featured-video .no-cookie-video").classList.remove('map-section__overlay');
    } else {
        document.querySelector(".featured-video .no-cookie-video").classList.add('map-section__overlay');
    }
});

/**
 * Opens the OneTrust cookie settings when the CTA is clicked.
 */
document.querySelector(".featured-video #cookies-setting-cta").addEventListener('click', function() {
    OneTrust.ToggleInfoDisplay();
});

/**
 * Handles window load event and adds event listeners to OneTrust buttons.
 */
window.onload = function() {
    // Remove overlay when user saves preferences
    const savePreferenceBtn = document.querySelector("button.save-preference-btn-handler.onetrust-close-btn-handler");
    if (savePreferenceBtn) {
        savePreferenceBtn.addEventListener('click', function() {
            document.querySelector(".featured-video .no-cookie-video").classList.remove('map-section__overlay');
        });
    }
    
    document.body.addEventListener('click', (e) => {
        if(e.target.closest('#accept-recommended-btn-handler') || e.target.closest('.save-preference-btn-handler.onetrust-close-btn-handler')) {
            location.reload();
        }
    })

    // Reload page when user accepts recommended settings
    const acceptRecommendedBtn = document.querySelector("button#accept-recommended-btn-handler");
    if (acceptRecommendedBtn) {
        acceptRecommendedBtn.addEventListener('click', function() {
            location.reload();
        });
    }
};
